import { render, staticRenderFns } from "./WhyPremium.vue?vue&type=template&id=6254498e&scoped=true&"
import script from "./WhyPremium.vue?vue&type=script&lang=js&"
export * from "./WhyPremium.vue?vue&type=script&lang=js&"
import style0 from "./WhyPremium.vue?vue&type=style&index=0&id=6254498e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6254498e",
  null
  
)

export default component.exports